/**
 * @ipc/admin-ui · app/main — точка входа SPA.
 * Провайдеры: ThemeProvider (реактивная тема) → QueryClientProvider (server-state) →
 * TooltipProvider (общий контекст Radix-тултипов) → RouterProvider (маршруты).
 * Toaster (sonner) — глобальные уведомления. globals.css —
 * Tailwind v4 + токены темы + Manrope. No-flash .dark ставится в index.html до рендера.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider, initTelegramWebApp, isTelegramWebApp } from '@/shared/lib';
import { createQueryClient } from '@/shared/api';
import { Toaster, TooltipProvider } from '@/shared/ui';
import { router } from './router';
import './globals.css';

// TWA: ready/expand/fullscreen + safe-area CSS vars до первого paint,
// чтобы .twa-safe-insets не прыгал после mount.
if (isTelegramWebApp()) {
  initTelegramWebApp();
}

// react-grab (dev-only): наведи на элемент → ⌘/Ctrl+C копирует путь к файлу,
// позицию (file.tsx:line:col) и стек компонентов для вставки агенту. Настройка
// глубины контекста — в app/dev/react-grab. В prod-бандл не попадает.
if (import.meta.env.DEV) {
  void import('./dev/react-grab').then(({ setupReactGrab }) => setupReactGrab());
}

const queryClient = createQueryClient();

const rootEl = document.getElementById('root');
if (rootEl === null) {
  throw new Error('Корневой элемент #root не найден в index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <RouterProvider router={router} />
          <Toaster position="top-right" richColors />
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
